type FrameNode = {
    frameId?: number | string | null
    frameType?: string | null
    frameContent?: any
}

const getChildFrames = (node: FrameNode | null | undefined): FrameNode[] => {
    if (!node) return []

    if (Array.isArray(node.frameContent)) return node.frameContent
    if (Array.isArray(node.frameContent?.contents)) return node.frameContent.contents

    return []
}

const collectSubpagesFrames = (node: FrameNode | null | undefined, frames: FrameNode[] = []) => {
    if (!node) return frames

    if (node.frameType === 'subpages') {
        frames.push(node)
    }

    getChildFrames(node).forEach((child) => collectSubpagesFrames(child, frames))

    return frames
}

export const hasSubpagesFrame = (section: FrameNode | null | undefined) => (
    collectSubpagesFrames(section).length > 0
)

export const isImportedHomePreviewCandidate = (section: any) => (
    Boolean(section?.frameOrigin && hasSubpagesFrame(section))
)

export const getPreviewSubpagesContent = (
    previewSection: any,
    frameId?: number | string | null,
) => {
    const previewFrames = collectSubpagesFrames(previewSection)

    if (!previewFrames.length) return null

    if (frameId !== undefined && frameId !== null) {
        const matchedFrame = previewFrames.find((frame) => String(frame?.frameId) === String(frameId))

        if (matchedFrame) return matchedFrame.frameContent ?? null
    }

    return previewFrames[0]?.frameContent ?? null
}
